/* global krpanoJS, removepano, embedpano */
// module wrapper for globally installed krpano

export const krpanoJS = window.krpanoJS
export const removepano = window.removepano
export const embedpano = window.embedpano



// WEBPACK FOOTER //
// ./src/js/pano/krpano.js